import { render } from "./ReferralDrawer.vue?vue&type=template&id=b138970e&scoped=true"
import script from "./ReferralDrawer.vue?vue&type=script&lang=js"
export * from "./ReferralDrawer.vue?vue&type=script&lang=js"

import "./ReferralDrawer.vue?vue&type=style&index=0&id=b138970e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b138970e"]])

export default __exports__